import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  boxButtons: {
    flexDirection: 'row',
  },
}))

export default styles
